import { skipToken, useQuery } from '@apollo/client/react';

import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { energyTariffs } from '@utils/queries/energy';

const useEnergyTariffsQuery = ({ skip = false }: { skip?: boolean } = {}) => {
  const { basketId } = useBasketContext();
  const { loading, data, error } = useQuery(
    energyTariffs,
    // https://www.apollographql.com/docs/react/data/queries#skipping-queries-with-skiptoken
    skip
      ? skipToken
      : {
          variables: { basketId },
          notifyOnNetworkStatusChange: true,
        }
  );

  return {
    loading,
    tariffs: data?.energyTariffs?.tariffs,
    nextTariffs: data?.energyTariffs?.nextTariffs ?? undefined,
    secondNextTariffs: data?.energyTariffs?.secondNextTariffs ?? undefined,
    error,
  };
};

export { useEnergyTariffsQuery };
